import { render, staticRenderFns } from "./complainSuccess.vue?vue&type=template&id=1fc607d0&scoped=true&"
import script from "./complainSuccess.vue?vue&type=script&lang=js&"
export * from "./complainSuccess.vue?vue&type=script&lang=js&"
import style0 from "./complainSuccess.vue?vue&type=style&index=0&id=1fc607d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc607d0",
  null
  
)

export default component.exports